// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"cb4ec9cdae8abbad","6831":"7821007b1293417b","8503":"4d10e0b22802a233","9683":"044545c0fa88397e"}[chunkId] + ".js";
};